import { render } from "./BasePage.vue?vue&type=template&id=135b30ef&scoped=true&ts=true"
import script from "./BasePage.vue?vue&type=script&lang=ts"
export * from "./BasePage.vue?vue&type=script&lang=ts"

import "./BasePage.vue?vue&type=style&index=0&id=135b30ef&scoped=true&lang=css"

import exportComponent from "/app/frontend-danahealth/dsg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-135b30ef"]])

export default __exports__